import React from 'react';
import {
    igaPaw01,
    igaPaw02,
    igaPaw03,
    igaPaw04,
    igaPaw05,
    igaPaw06,
    igaPaw07,
    igaPaw08,
    igaPaw09,
    igaPaw10,
    igaPaw11,
    igaPaw12,
    igaPaw13,
    igaPaw14,
    igaPaw15,
    igaPaw16,
    igaPaw17,
    igaPaw18,
    igaPaw19,
    igaPaw20,
    igaPaw21,
    igaPaw22,
    igaPaw23,
    igaPaw24,
    igaPaw25,
    igaPaw26,
    igaPaw27,
    igaPaw28,
    igaPaw29,
    igaPaw30,
    igaPaw31,
    main,

} from '../OurCouplesPics/IgaPawel';

export const IgaAndPawel = {
    bgColor: "bgGrey",
    title: "Iga i Paweł – miejskie wesele w Belvedere",
    path: "miejskie-wesele-w-belvedere",
    minHeight: true,
    seoTitle: "Iga i Paweł – miejskie wesele w Belvedere",
    seoText: "Nowoczesna elegancja, odważna czerwień i muzyka, która porwała wszystkich – wesele Igi i Pawła w warszawskim Belvedere to połączenie miejskiego stylu i wyrazistej energii.",
    mainPic: {
        src: main
    },
    details: "Nowoczesna elegancja, odważna czerwień i muzyka, która porwała wszystkich – wesele Igi i Pawła w warszawskim Belvedere to połączenie miejskiego stylu i wyrazistej energii.",
    org: "Agencja Ślubna Czary Marry",
    orgLink: "",
    place: "Restauracja Belvedere, Warszawa",
    placeLink: "",
    photo: "Klaudia, Yes I Do",
    photoLink: "",
    decor: "Mizu Mizu",
    decorLink: "",
    music: "Dominik – Fabryka Imprez",
    musicLink: "",
    date: "25 gru 2025",
    textMain:
        "Niektóre pary od pierwszego spotkania wiedzą, czego chcą. Mają jasną wizję, wyczucie stylu i konsekwencję w działaniu. Iga i Paweł byli właśnie tacy – świadomi swoich wyborów, dążący do perfekcji w każdym detalu. Ich wesele w warszawskiej restauracji Belvedere było połączeniem nowoczesnej elegancji, miejskiego charakteru i wyrazistej energii.",
    topPic: { src: main },
    content: [
        {
            headerSmall: 'Przygotowania w rytmie spokoju',
            headerClassName: "grey",
            text: <>
                <p>Dzień rozpoczął się spokojnie, w mieszkaniu pary. Zamiast pośpiechu i stresu – cisza, wspólne śniadanie, ich ukochany pies i kilka chwil tylko dla siebie. To była przestrzeń, w której Iga i Paweł mogli złapać oddech przed pełnym emocji dniem.</p><p>Iga w asymetrycznej, minimalistycznej sukni wyglądała zachwycająco – prosta forma, perfekcyjny krój i krótkie, ciemne włosy dodawały jej nowoczesnego, paryskiego wdzięku. Paweł w klasycznym, czarnym garniturze i muszce prezentował się ponadczasowo – elegancko, ale bez nadęcia. Razem tworzyli duet, w którym każdy szczegół był dopracowany, a ich styl idealnie wpisywał się w klimat miejskiej elegancji.</p></>,
            pics: [
                { src: igaPaw01 },
                { src: igaPaw02 },
                { src: igaPaw03 },
                { src: igaPaw04 },
                { src: igaPaw05 },
                { src: igaPaw06 },
                { src: igaPaw07 },
            ]
        },
        {
            headerSmall: "Ceremonia w ogrodzie Belvedere",
            headerClassName: "grey",
            text: <>
                <p>
                    Ślub cywilny odbył się w ogrodzie restauracji Belvedere – miejscu, które zachwyca naturalnym światłem i otoczeniem parku. To była uroczystość w duchu klasyki – prosta, ale pełna emocji. Muzyka na żywo w wykonaniu Doroty Sacewicz i akompaniament instrumentów dodały jej wyjątkowej oprawy.
                </p>
                <p>
                    Po ceremonii goście zostali zaproszeni na koktajl w ogrodzie. W cieniu drzew, przy dźwiękach rozmów i brzęku kieliszków, rozpoczął się ten wyjątkowy wieczór – pełen elegancji, spokoju i lekkości.
                </p>
            </>,
            pics: [
                { src: igaPaw08 },
                { src: igaPaw09 },
                { src: igaPaw10 },
                { src: igaPaw11 },
                { src: igaPaw12 },
                { src: igaPaw13 },
                { src: igaPaw14 },
                { src: igaPaw15 },
                { src: igaPaw16 },
                { src: igaPaw17 },
            ]
        },
        {
            headerSmall: "Dekoracje w czerwieni",
            headerClassName: "grey",
            text: <>
                <p>Dekoracje przygotowane przez Mizu Mizu były jedyne w swoim rodzaju – odważne, wyraziste i spójne z całą koncepcją przyjęcia. Motywem przewodnim była gloriosa – kwiat o rzeźbiarskiej formie i intensywnym kolorze.</p>
                <p>Na stołach pojawiły się wysokie kompozycje w odcieniach czerwieni i zieleni, które pięknie kontrastowały z miodowymi obrusami i naturalną zielenią ścian oranżerii. Wnętrze wypełniały złote akcenty i miękkie światło świec, które podkreślały wieczorny klimat. Czerwień w detalach – serwetkach, papeterii i szkle – nadawała całości nowoczesnego, ale eleganckiego charakteru.</p>
                <p>Każdy element był przemyślany: od form naczyń, przez tonację kolorystyczną, po sposób ułożenia kwiatów. To była dekoracja z klasą, w której nic nie było przypadkowe.</p>
            </>,
            pics: [

                { src: igaPaw18 },
                { src: igaPaw19 },
                { src: igaPaw20 },
                { src: igaPaw21 },
                { src: igaPaw22 },
                { src: igaPaw23 },
            ]
        },
        {
            headerSmall: "Wesele pełne światła i muzyki",
            headerClassName: "grey",
            text: <>
                <p>Gdy zapadł zmrok, Belvedere zamieniło się w stylowy klub. Parkiet rozświetliły ciepłe refleksy światła, a pierwsze dźwięki muzyki wywołały falę energii, która nie opuściła gości aż do końca nocy.</p>
                <p>Za konsoletą stanął Dominik z Fabryki Imprez, który stworzył wyjątkowy klimat – łącząc klubowe brzmienia z eleganckim tonem przyjęcia. Było dynamicznie, nowocześnie i stylowo – dokładnie tak, jak chciała Para Młoda.</p>
                <p>Pierwszy taniec otworzył parkiet w klasycznym, ale pełnym emocji stylu, a zamiast tradycyjnego tortu pojawiły się eleganckie monoporcje – dopracowane, piękne i pyszne. Wieczór płynął w rytmie rozmów, muzyki i świateł – w idealnym balansie pomiędzy elegancją a swobodą.</p>
            </>,
            pics: [
                { src: igaPaw24 },
                { src: igaPaw25 },
                { src: igaPaw26 },
                { src: igaPaw27 },
                { src: igaPaw28 },
            ]
        },
        {
            headerSmall: "Nowoczesna elegancja z charakterem",
            headerClassName: "grey",
            text: <>
                <p>
                    Wesele Igi i Pawła było dokładnie takie jak oni – świadome, dopracowane, z charakterem. Miejski szyk, wyrafinowana prostota i energia, która niosła się po całym parkiecie.</p>
                <p>
                    To dowód na to, że klasyka nie musi być zachowawcza, a elegancja może mieć swój rytm i moc.</p>
            </>,
            pics: [
                { src: igaPaw29 },
                { src: igaPaw30 },
                { src: igaPaw31 }
            ]
        },
    ],
}